import { ColumnDef } from "@tanstack/react-table"
import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React from "react"
import { FormattedNumber } from "react-intl"
import { CurrencyColumnDefinition, TableRowData } from "../../../../../../state/listing/generic-listing/column-definitions"
import Icon from "../../../../../icon/icon.component"

export default (columnDefinition: CurrencyColumnDefinition): Partial<ColumnDef<TableRowData>> => ({
    cell: info => {
        const value = info.getValue() as string

        if (value) {
            const currency = info.row.original.currency || AppContext.getAccount().attributes.currency

            if (columnDefinition.dataAttributes?.showPaidAmount ?? false) {
                const paidAmount = info.row.original[columnDefinition.dataAttributes?.paidAmountKey ?? ""] ?? 0

                return (
                    <div className='d-flex align-items-center justify-content-between'>
                        {parseFloat(paidAmount) > 0 ? (
                            <div className='badge badge-pill badge-secondary mr-2'>
                                <Icon value="coins" className="mr-1" />
                                <FormattedNumber
                                    style="currency"
                                    currency={currency}
                                    value={paidAmount}
                                />
                            </div>
                        ) : (
                            <div></div>
                        )}
                        <div>
                            <FormattedNumber
                                style="currency"
                                currency={currency}
                                value={value}
                            />
                        </div>
                    </div>
                )
            }

            return (
                <FormattedNumber
                    style="currency"
                    currency={currency}
                    value={value}
                />
            )
        }

        return columnDefinition.dataAttributes?.defaultValue || "-"
    }
})


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/listing-table/mappers/cell-mappers/CurrencyCellMapper.tsx